import React from "react";
import SEO from "@/components/SEO";

export default function PoliticaPrivacidad() {
  return (
    // El navbar es fijo (h-16 móvil, h-20 escritorio) y ahora, encima,
    // también la cinta promocional (~37px). Esta página no reservaba ningún
    // espacio propio: el titular quedaba tapado debajo.
    <main className="min-h-screen bg-card text-foreground pt-28 md:pt-32">
      <SEO
        title="Política de Privacidad"
        description="Política de privacidad y tratamiento de datos personales de la Delegación de Evangelización Digital de la Diócesis de Huelva."
      />
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold text-[#1a3a6b] mb-2">
          Política de Privacidad
        </h1>

        <p className="text-sm text-gray-500 mb-8">
          Fecha de entrada en vigor: 21/04/2026, 17:57:04
        </p>

        <section className="space-y-6 leading-8 text-lg">
          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Introducción e información organizativa
            </h2>

            <p>
              En la Delegación de Evangelización Digital nos dedicamos a servir a
              nuestros usuarios y contactos de la mejor manera posible. Parte de
              este compromiso implica la gestión responsable de la información
              personal recopilada a través de nuestro sitio web
              evangelizaciondigitalhuelva.org y de cualquier interacción
              relacionada.
            </p>

            <p>
              Nuestros principales objetivos al tratar esta información incluyen:
            </p>

            <ul className="list-disc pl-6 space-y-2">
              <li>
                Mejorar la experiencia del usuario en nuestra plataforma
                comprendiendo sus necesidades y preferencias.
              </li>
              <li>
                Proporcionar asistencia oportuna y responder a consultas o
                solicitudes de servicio.
              </li>
              <li>
                Mejorar nuestros productos y servicios para adaptarnos a las
                necesidades cambiantes de nuestros usuarios.
              </li>
              <li>
                Realizar operaciones comerciales necesarias, como la facturación
                y la gestión de cuentas.
              </li>
            </ul>

            <p>
              Nuestra política es tratar la información personal con el máximo
              respeto a la privacidad y la seguridad. Cumplimos con todas las
              normativas y directrices pertinentes para garantizar que los datos
              que manejamos estén protegidos frente a accesos no autorizados,
              divulgación, alteración y destrucción.
            </p>

            <p>
              Nuestras prácticas están diseñadas para salvaguardar la
              confidencialidad e integridad de su información personal,
              permitiéndonos al mismo tiempo ofrecer los servicios que nos
              confía.
            </p>

            <p>
              No contamos con un Delegado de Protección de Datos (DPO)
              designado, pero seguimos plenamente comprometidos con atender
              cualquier cuestión relacionada con la privacidad. Para cualquier
              duda o información adicional sobre cómo gestionamos los datos
              personales, puede contactarnos en{" "}
              <a
                href="mailto:evangelizaciondigital@diocesisdehuelva.es"
                className="text-blue-700 underline"
              >
                evangelizaciondigital@diocesisdehuelva.es
              </a>{" "}
              o en el teléfono{" "}
              <a
                href="tel:+34959252100"
                className="text-blue-700 underline"
              >
                +34 959252100
              </a>
              .
            </p>

            <p>
              Su privacidad es nuestra prioridad. Nos comprometemos a tratar su
              información personal de forma transparente y segura. Este
              compromiso se extiende a nuestra colaboración con terceros que
              puedan tratar datos personales en nuestro nombre, como en el caso
              del envío de facturas.
            </p>

            <p>
              Todas las actividades se realizan en estricto cumplimiento de la
              normativa vigente en materia de protección de datos.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Alcance y aplicación
            </h2>

            <p>
              Nuestra política de privacidad está diseñada para proteger la
              información personal de todas las personas relacionadas con
              nosotros, incluyendo visitantes del sitio web, usuarios
              registrados y clientes.
            </p>

            <p>
              Tanto si navega por evangelizaciondigitalhuelva.org, como si
              utiliza nuestros servicios o interactúa con nosotros como cliente,
              garantizamos que sus datos personales se tratan con los más altos
              estándares de privacidad y seguridad.
            </p>

            <p>
              Esta política describe nuestras prácticas y sus derechos en
              relación con la información personal.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Almacenamiento y protección de datos
            </h2>

            <h3 className="text-xl font-semibold mt-4 mb-2">
              Almacenamiento de datos
            </h3>
            <p>
              La información personal se almacena en servidores seguros ubicados
              en: ES. En caso de transferencias internacionales de datos,
              garantizamos que se cumplan todas las leyes aplicables y que se
              mantengan estándares equivalentes de protección.
            </p>

            <h3 className="text-xl font-semibold mt-4 mb-2">
              Proveedores de alojamiento
            </h3>
            <p>
              Colaboramos con proveedores de alojamiento de datos de reconocido
              prestigio, comprometidos con el uso de medidas de seguridad
              avanzadas. Estos proveedores son seleccionados en función de su
              cumplimiento de estrictos estándares de protección de datos.
            </p>

            <h3 className="text-xl font-semibold mt-4 mb-2">
              Acuerdos de tratamiento de datos
            </h3>
            <p>
              Cuando compartimos sus datos con terceros, lo hacemos bajo
              Acuerdos de Tratamiento de Datos (DPA) que garantizan que la
              información se gestione conforme al RGPD y demás normativas
              aplicables.
            </p>
            <p>
              Estos acuerdos obligan a los terceros a aplicar medidas técnicas y
              organizativas adecuadas.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Transparencia y control
            </h2>

            <p>
              Creemos en la transparencia y en ofrecerle control sobre su
              información personal. Siempre será informado de cambios relevantes
              en nuestras prácticas de intercambio de datos y, cuando sea
              necesario, podrá otorgar su consentimiento.
            </p>

            <p>
              Su confianza es fundamental para nosotros. Nos esforzamos por
              garantizar que su información personal solo se comparta conforme a
              esta política y cuando exista una razón justificada.
            </p>

            <p>
              Para cualquier consulta, puede escribir a{" "}
              <a
                href="mailto:evangelizaciondigital@diocesisdehuelva.es"
                className="text-blue-700 underline"
              >
                evangelizaciondigital@diocesisdehuelva.es
              </a>{" "}
              o llamar al{" "}
              <a
                href="tel:+34959252100"
                className="text-blue-700 underline"
              >
                +34 959252100
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Derechos del usuario
            </h2>

            <p>
              En la Delegación de Evangelización Digital reconocemos y
              respetamos sus derechos conforme al Reglamento General de
              Protección de Datos (RGPD) y demás normativas aplicables:
            </p>

            <ul className="list-disc pl-6 space-y-2">
              <li>
                Derecho de acceso (Art. 15 RGPD): Puede solicitar acceso a sus
                datos personales y conocer cómo los tratamos.
              </li>
              <li>
                Derecho de rectificación (Art. 16 RGPD): Puede solicitar la
                corrección de datos inexactos o incompletos.
              </li>
              <li>
                Derecho de supresión (Art. 17 RGPD): Puede solicitar la
                eliminación de sus datos cuando ya no sean necesarios.
              </li>
              <li>
                Derecho a la limitación del tratamiento (Art. 18 RGPD).
              </li>
              <li>
                Derecho a la portabilidad de los datos (Art. 20 RGPD).
              </li>
              <li>Derecho de oposición (Art. 21 RGPD).</li>
              <li>
                Derecho a retirar el consentimiento (Art. 7.3 RGPD).
              </li>
              <li>
                Derecho a presentar una reclamación (Art. 77 RGPD).
              </li>
            </ul>

            <h3 className="text-xl font-semibold mt-4 mb-2">
              Ejercicio de derechos
            </h3>
            <p>
              Puede ejercer estos derechos escribiendo a{" "}
              <a
                href="mailto:evangelizaciondigital@diocesisdehuelva.es"
                className="text-blue-700 underline"
              >
                evangelizaciondigital@diocesisdehuelva.es
              </a>{" "}
              o llamando al{" "}
              <a
                href="tel:+34959252100"
                className="text-blue-700 underline"
              >
                +34 959252100
              </a>
              . Responderemos conforme a los plazos legales. En algunos casos,
              podremos solicitar verificación de identidad.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Cookies y tecnologías de seguimiento
            </h2>

            <p>
              Utilizamos cookies y tecnologías similares para garantizar el
              correcto funcionamiento del sitio, mejorar su experiencia y
              obtener información para optimizar nuestros servicios.
            </p>

            <p>Tipos de cookies:</p>

            <ul className="list-disc pl-6 space-y-2">
              <li>Esenciales: necesarias para el funcionamiento del sitio.</li>
              <li>De análisis: ayudan a mejorar el sitio web.</li>
              <li>Funcionales: recuerdan sus preferencias.</li>
              <li>Publicitarias: muestran anuncios relevantes.</li>
            </ul>

            <h3 className="text-xl font-semibold mt-4 mb-2">
              Consentimiento
            </h3>
            <p>En su primera visita podrá:</p>

            <ul className="list-disc pl-6 space-y-2">
              <li>Aceptar todas las cookies.</li>
              <li>Rechazar las no esenciales.</li>
              <li>Configurar sus preferencias.</li>
            </ul>

            <p>
              Más información en:{" "}
              <a
                href="/politica-de-cookies"
                className="text-blue-700 underline"
              >
                politica-de-cookies
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Privacidad de los menores
            </h2>

            <p>
              Nuestros servicios no están dirigidos a menores de 18 años. No
              recopilamos intencionadamente datos de menores sin consentimiento
              verificable de sus padres o tutores.
            </p>

            <p>
              Si detectamos que se han recopilado datos de un menor sin
              consentimiento, procederemos a eliminarlos. Los padres o tutores
              pueden solicitar acceso, modificación o eliminación de los datos
              de sus hijos.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#1a3a6b] mb-4">
              Notificación de brechas de seguridad
            </h2>

            <p>En caso de una violación de datos:</p>

            <ul className="list-disc pl-6 space-y-2">
              <li>
                Detección y evaluación: contamos con sistemas de seguridad para
                detectar incidentes.
              </li>
              <li>
                Notificación a autoridades: cuando sea necesario, informaremos
                en un plazo de 30 días.
              </li>
              <li>
                Notificación a afectados: si existe riesgo significativo, se
                notificará también en 30 días.
              </li>
            </ul>

            <p>Canales de comunicación:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Notificación por correo electrónico cuando sea posible.</li>
            </ul>

            <p>Apoyo a los afectados:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Ofrecemos orientación y asistencia para minimizar riesgos.
              </li>
            </ul>

            <p>
              Para cualquier incidencia o duda:{" "}
              <a
                href="mailto:evangelizaciondigital@diocesisdehuelva.es"
                className="text-blue-700 underline"
              >
                evangelizaciondigital@diocesisdehuelva.es
              </a>{" "}
              |{" "}
              <a
                href="tel:+34959252100"
                className="text-blue-700 underline"
              >
                +34 959252100
              </a>
            </p>
          </div>

          <div>
            <p className="font-medium text-[#1a3a6b]">
              Su privacidad y la protección de sus datos son fundamentales para
              nosotros.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
